module.exports = __webpack_public_path__ + "media/images/area/feature/tohoku/related/th/1-d06621b777240b699f0de73e84a1cd63.jpg";